/* Pause / resume control for an auto-rotating slideshow (sections/slideshow.liquid). */
if (!customElements.get('slideshow-autoplay-toggle')) {
  customElements.define(
    'slideshow-autoplay-toggle',
    class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        const slider = this.closest('vesper-slider');
        if (!button || !slider) return;
        button.addEventListener('click', () => {
          const paused = button.getAttribute('aria-pressed') === 'true';
          if (paused) slider.play?.(true);
          else slider.pause?.(true);
          button.setAttribute('aria-pressed', paused ? 'false' : 'true');
          button.setAttribute('aria-label', paused ? button.dataset.pauseLabel : button.dataset.playLabel);
        });
      }
    }
  );
}
